import { makeStyles, Theme } from '@material-ui/core/styles';

/** Layout scaffolding for the per-tab loading skeletons. */
const useStyles = makeStyles((theme: Theme) => ({
  tab: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    width: '100%',
  },
  row: {
    display: 'flex',
    gap: 12,
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  card: {
    border: `1px solid ${theme.palette.grey3}`,
    borderRadius: 16,
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
  },
  cardGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: 16,
  },
  splitGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 20,
    [theme.breakpoints.up('tablet')]: {
      gridTemplateColumns: 'minmax(0, 1.1fr) minmax(0, 1fr)',
    },
  },
  mapGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 16,
    [theme.breakpoints.up('large')]: {
      gridTemplateColumns: 'minmax(0, 2fr) minmax(0, 1fr)',
    },
  },
  calendarGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gap: 8,
  },
  peopleGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(230px, 1fr))',
    gap: 16,
  },
  table: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  tableHead: {
    display: 'grid',
    gap: 12,
    paddingBottom: 12,
    borderBottom: `1px solid ${theme.palette.grey3}`,
  },
  tableRow: {
    display: 'grid',
    gap: 12,
    alignItems: 'center',
  },
  chipRow: {
    display: 'flex',
    gap: 10,
    flexWrap: 'wrap',
  },
  grow: {
    flex: 1,
    minWidth: 160,
  },
  page: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    width: '100%',
    maxWidth: 1180,
    margin: '0 auto',
    padding: '24px 0',
  },
  pageHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
}));

export default useStyles;
